export { default } from "./resolveComponentProps.mjs";